export default function() {
  return Boolean(!this.model.get("jigsaw-error"));
}
